// Platform (superadmin only): the commercial record of one workshop (plan,
// pilot, discounts, payment, notes) and the switch of its customer links. `talleres_` keeps it out of the list
// page's layout.
import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { exigir } from '@/lib/guardias';
import { permisos } from '@/lib/sesion';
import { EnlacesPublicos } from '@/plataforma/EnlacesPublicos';
import { FichaComercialTaller } from '@/plataforma/FichaComercial';
import { Boton } from '@/ui/boton';
import { Contenedor } from '@/ui/pagina';

export const Route = createFileRoute('/_app/plataforma/talleres_/$tallerId/comercial')({
  beforeLoad: exigir(permisos.plataforma),
  component: Pagina,
});

function Pagina() {
  const { tallerId } = Route.useParams();
  return (
    <Contenedor ancho="angosto" className="lg:max-w-[1120px]">
      <FichaComercialTaller
        key={tallerId}
        tallerId={tallerId}
        volver={
          <Boton asChild variante="enlace" tamano="sm" className="self-start">
            <Link to="/plataforma/talleres">
              <ArrowLeft /> Talleres
            </Link>
          </Boton>
        }
      />
      <EnlacesPublicos key={`enlaces-${tallerId}`} tallerId={tallerId} />
    </Contenedor>
  );
}
